import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Page } from "@rentiohq/web-shared/dist/components";

const NotFound = () => (
  <Page title={getLocalizedText("page_not_found.title")} />
);

// eslint-disable-next-line import/no-default-export
export default NotFound;
